<div class="page-wrapper">
    <div class="content-wrapper">
        <ng-content></ng-content>
    </div>
</div>
<div class="logo-wrapper">
    <img src="assets/img/misc/logo-{{lang || 'nl'}}.svg" alt="logo" width="230">
</div>
<div class="footer">
    <span>&copy; MilkBE</span>
    <span class="links">
        <a href='/nl/terms-of-use' target="_blank">{{ 'terms_of_use' | translate }}</a>
        <a href='/nl/cookie-policy' target="_blank">{{ 'cookie_policy' | translate }}</a>
        <a href='/nl/privacy-policy' target="_blank">{{ 'privacy_policy' | translate }}</a>
    </span>
</div>